<n-slide-window *ngIf="pageReady"
    width="8rem"
    [visible]="windowVisible"
    (onHide)="close()">
    <n-header class="flex-wrapper">
        <h1>{{i18n.systemInfoText}}</h1>
        <n-help-link key="storagesysConfig"></n-help-link>
    </n-header>
    <form class="form-wrapper"
        [formGroup]="vm"
        [errorMessage]="errorMessage">
        <n-form-item *ngIf="!isEditName" [label]="i18n.nameLab">
            <span class="text-wrap">{{vm.value.name}}</span>
            <button *ngIf="!isEditing && hasSystemW"
                id="systemInfo_editNameBtn"
                type="button"
                class="icon-btn"
                style="margin-left: .1rem;"
                (click)="isEditName = true">
                <svg class="icon">
                    <use xlink:href="#icon-edit"></use>
                </svg>
            </button>
        </n-form-item>
        <n-form-item *ngIf="isEditName" [label]="i18n.nameLab">
            <div class="interval-10">
                <input type="text"
                    id="systemInfo_nameField"
                    pInputText
                    formControlName="name" />
                <button class="icon-btn ok"
                    id="systemInfo_saveNameBtn"
                    type="button"
                    (click)="saveDeviceInfo()">
                    <svg class="icon">
                        <use xlink:href="#icon-ok"></use>
                    </svg>
                </button>
                <button class="icon-btn close"
                    id="systemInfo_cancelEditNameBtn"
                    type="button"
                    (click)="cancelEdit()">
                    <svg class="icon">
                        <use xlink:href="#icon-close"></use>
                    </svg>
                </button>
            </div>
        </n-form-item>
        <n-form-item [label]="i18n.modelName">
            <span class="pre-wrap">{{vm.value.model}}</span>
        </n-form-item>
        <n-form-item *ngIf="!isEditLocation" [label]="i18n.locationLab">
            <div style="width: 100%">
                <span class="text-wrap">{{vm.value.location || UNPLACEHOLDER}}</span>
                <button *ngIf="!isEditing && hasSystemW"
                    id="systemInfo_editLocationBtn"
                    type="button"
                    class="icon-btn"
                    style="margin-left: .1rem;"
                    (click)="isEditLocation = true">
                    <svg class="icon">
                        <use xlink:href="#icon-edit"></use>
                    </svg>
                </button>
            </div>
        </n-form-item>
        <n-form-item *ngIf="isEditLocation" [label]="i18n.locationLab">
            <div class="interval-10">
                <input type="text"
                    id="systemInfo_locationField"
                    pInputText
                    formControlName="location" />
                <button type="button"
                    id="systemInfo_saveLocationBtn"
                    class="icon-btn ok"
                    (click)="saveDeviceInfo()">
                    <svg class="icon">
                        <use xlink:href="#icon-ok"></use>
                    </svg>
                </button>
                <button class="icon-btn close"
                    id="systemInfo_cancelEditLocationBtn"
                    type="text"
                    (click)="cancelEdit()">
                    <svg class="icon">
                        <use xlink:href="#icon-close"></use>
                    </svg>
                </button>
            </div>
        </n-form-item>

        <ng-container *ngIf="(supportDedupeAndCompression || supportGuaranteedCapacity) && hasReadGuaranteedCapPermission">
            <n-form-item [label]="supportGeneralGuranteedCapacity && !supportDedupeAndCompression
                ? i18n.guaranteedCapacityLab
                : i18n.totalCapacityLab">
                <span>{{guaranteedCapacity}}</span>
            </n-form-item>
            <ng-container *ngIf="supportGeneralGuranteedCapacity && !supportDedupeAndCompression"
                formGroupName="threshold">
                <n-form-item [label]="i18n.insufficientThresholdLab">
                    <div *ngIf="isEditInsufficientThreshold && hasWriteGuaranteedCapPermission"
                        class="interval-10">
                        <n-spinner id="system-info-insufficent"
                            [onlyInput]="true"
                            [min]="1"
                            [max]="95"
                            formControlName="insufficientThreshold">
                        </n-spinner>
                        <span>{{rangeTip | fn :1 :95}}</span>
                        <button type="button"
                            id="systemInfo_saveInsufficientThresholdBtn"
                            class="icon-btn ok"
                            (click)="saveGuaranteedCapacity()">
                            <svg class="icon">
                                <use xlink:href="#icon-ok"></use>
                            </svg>
                        </button>
                        <button class="icon-btn close"
                            id="systemInfo_cancelInsufficientThresholdBtn"
                            type="text"
                            (click)="cancelEdit()">
                            <svg class="icon">
                                <use xlink:href="#icon-close"></use>
                            </svg>
                        </button>
                    </div>
                    <div class="interval-10" *ngIf="!isEditInsufficientThreshold">
                        <span>{{vm.value.threshold.insufficientThreshold}}</span>
                        <button *ngIf="!isEditing && hasWriteGuaranteedCapPermission"
                            id="systemInfo_editInsufficientThresholdBtn"
                            type="button"
                            class="icon-btn"
                            style="margin-left: .1rem;"
                            (click)="isEditInsufficientThreshold = true">
                            <svg class="icon">
                                <use xlink:href="#icon-edit"></use>
                            </svg>
                        </button>
                    </div>
                </n-form-item>
                <n-form-item [label]="i18n.usedUpThresholdLab">
                    <div *ngIf="isEditUsedUpThreshold && hasWriteGuaranteedCapPermission"
                        class="interval-10">
                        <n-spinner id="system-info-used-threshold"
                            [onlyInput]="true"
                            [min]="2"
                            [max]="99"
                            formControlName="usedUpThreshold">
                        </n-spinner>
                        <span>{{rangeTip | fn :2 :99}}</span>
                        <button type="button"
                            id="systemInfo_saveUsedUpThresholdBtn"
                            class="icon-btn ok"
                            (click)="saveGuaranteedCapacity()">
                            <svg class="icon">
                                <use xlink:href="#icon-ok"></use>
                            </svg>
                        </button>
                        <button class="icon-btn close"
                            id="systemInfo_cancelUsedUpThresholdBtn"
                            type="text"
                            (click)="cancelEdit()">
                            <svg class="icon">
                                <use xlink:href="#icon-close"></use>
                            </svg>
                        </button>
                    </div>
                    <div class="interval-10" *ngIf="!isEditUsedUpThreshold">
                        <span>{{vm.value.threshold.usedUpThreshold}}</span>
                        <button *ngIf="!isEditing && hasWriteGuaranteedCapPermission"
                            id="systemInfo_editUsedUpThresholdBtn"
                            type="button"
                            class="icon-btn"
                            style="margin-left: .1rem;"
                            (click)="isEditUsedUpThreshold = true">
                            <svg class="icon">
                                <use xlink:href="#icon-edit"></use>
                            </svg>
                        </button>
                    </div>
                </n-form-item>
            </ng-container>
        </ng-container>
        <n-form-item [label]="i18n.versionLab">
            <span>{{vm.value.version}}</span>
        </n-form-item>
        <n-form-item [label]="i18n.snLab">
            <span>{{vm.value.sn}}</span>
        </n-form-item>
        <n-form-item [label]="i18n.wwnLab">
            <span>{{vm.value.wwn}}</span>
        </n-form-item>
        <n-form-item [label]="i18n.diskCapacityLab" *ngIf="!SWITCH.IS_AvailableCap_MODE">
            <span>{{vm.value.totalCapacity}}</span>
        </n-form-item>
        <!-- 微存储体现当前模式-->
        <n-form-item [label]="i18n.typeLab" *ngIf="FeatureConfig.IsSupportOceanMicroModeAndMediaType">
            <span>{{valueForShowMode}}</span>
        </n-form-item>
        <!-- 微存储体现介质类型-->
        <n-form-item [label]="i18n.mediaTypeLab" *ngIf="FeatureConfig.IsSupportOceanMicroModeAndMediaType">
            <span>{{FeatureConfig.IsSupportSmartPool ? i18n.hybridFlashLab : i18n.allFlashLab}}</span>
        </n-form-item>
    </form>
    <n-footer>
        <button pButton
            id="systemInfo_closeBtn"
            type="button"
            [label]="i18n.closeBtn"
            (click)="windowVisible = false">
        </button>
    </n-footer>
</n-slide-window>
